export default "__VITE_ASSET__p9DT3QXM__"